import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Sparkles } from 'lucide-react';
const bonuses = [{
  n: 'BONO #1',
  icon: '🧘‍♀️',
  title: 'Kit Profesional de 52 Clases Express'
}, {
  n: 'BONO #2',
  icon: '✨',
  title: 'Banco de 100 Secuencias Premium'
}, {
  n: 'BONO #3',
  icon: '🎧',
  title: 'Biblioteca Premium de Meditaciones y Savasanas'
}, {
  n: 'BONO #4',
  icon: '📱',
  title: 'Kit de Marketing para Profes de Yoga'
}, {
  n: 'BONO #5',
  icon: '🏕️',
  title: 'Manual de Talleres, Retiros y Eventos'
}, {
  n: 'BONO #6',
  icon: '🖨️',
  title: 'Biblioteca Profesional de Recursos Imprimibles'
}];
export function BonusSection() {
  return <section className="py-24 lg:py-32 bg-transparent" data-id="element-15">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-16">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16 max-w-3xl mx-auto" data-id="element-17">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100 text-accent-800 font-medium text-xs uppercase tracking-widest mb-6 shadow-sm" data-id="element-18">
            <Gift className="w-4 h-4" data-id="element-19" /> 6 Regalos exclusivos
          </div>
          <h2 className="text-3xl md:text-5xl font-serif font-medium text-ink-900 mb-6 leading-tight tracking-tight" data-id="element-20">
            Además recibís{' '}
            <span className="text-accent-600 italic" data-id="element-21">6 bonos GRATIS</span>
          </h2>
          <p className="text-lg text-ink-600 font-light" data-id="element-22">
            Por reservar hoy, sumás $90.000 en bonos exclusivos sin pagar un
            peso más.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 mb-16" data-id="element-23">
          {bonuses.map((b, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="group relative bg-white rounded-[2rem] p-8 border border-accent-100/50 hover:border-accent-200 hover:shadow-md transition-all duration-300" data-id="element-24">
              {/* Bonus tag */}
              <div className="absolute -top-3 left-6 bg-accent-50 text-accent-700 text-[10px] font-medium px-4 py-1 rounded-full uppercase tracking-widest border border-accent-200/50" data-id="element-25">
                {b.n}
              </div>
              <div className="flex items-start gap-5 mt-4" data-id="element-26">
                <div className="text-4xl bg-[#FAF8F5] w-16 h-16 rounded-full flex items-center justify-center shrink-0 group-hover:scale-105 transition-transform duration-300" data-id="element-27">
                  {b.icon}
                </div>
                <div className="flex-1" data-id="element-28">
                  <h3 className="font-serif font-medium text-lg text-ink-900 mb-3 leading-tight" data-id="element-29">
                    {b.title}
                  </h3>
                  <div className="flex items-center gap-3 flex-wrap" data-id="element-30">
                    <span className="text-ink-400 line-through text-sm font-light" data-id="element-31">
                      $15.000
                    </span>
                    <span className="bg-accent-50 text-accent-700 font-medium text-[10px] px-3 py-1 rounded-full uppercase tracking-widest" data-id="element-32">
                      GRATIS
                    </span>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-2xl mx-auto bg-brand-900 rounded-[2.5rem] p-10 lg:p-12 text-center shadow-lg relative overflow-hidden" data-id="element-33">
          <div className="absolute top-0 right-0 w-64 h-64 bg-brand-700/30 rounded-full blur-3xl" data-id="element-34"></div>
          <div className="relative z-10" data-id="element-35">
            <Sparkles className="w-6 h-6 text-accent-400 mx-auto mb-4" data-id="element-36" />
            <p className="text-brand-200 font-medium mb-4 text-xs uppercase tracking-widest" data-id="element-37">
              Valor total de los bonos
            </p>
            <div className="flex items-center justify-center gap-6 text-4xl md:text-5xl font-serif font-medium" data-id="element-38">
              <span className="text-brand-700 line-through" data-id="element-39">$90.000</span>
              <span className="text-accent-400 italic" data-id="element-40">GRATIS</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}